import { I18n } from 'i18n-js';
import translations from '@/i18n/translations.json';

export default new I18n(translations);
